exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscConfirm[data-v-36461d5c]{color:#4f4f4f;background:#fff;padding:38px 30px 40px;max-width:580px;margin:auto}.subscConfirm__title[data-v-36461d5c]{font-size:21px;line-height:31px;text-align:center;margin:2px 0 25px}.subscConfirm__foot[data-v-36461d5c]{margin:40px 0 0}.subscConfirm__modify[data-v-36461d5c]{margin-bottom:20px}.subscConfirm .foot-notice[data-v-36461d5c]{margin:32px -10px}.loading[data-v-36461d5c]{position:fixed;z-index:3;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36461d5c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ChounDiary/SubscConfirmChoun.vue
// module id = xPID
// module chunks = 0